"use client";

import {JSX} from "react";

import {PopularPosts} from "@/sections/blog/popular-posts/popular-posts";
import {PopularPostsViewProps} from "@/sections/blog/popular-posts/popular-posts";

import {useUpdateEffect} from "@/shared/hooks";
import {useServerRouter} from "@/shared/hooks/navigation/use-server-router";
import {useModel} from "@/shared/hooks/state-management/use-model";

import {BlogsFilteredListInstance, createBlogsFilteredListModel} from "./blogs-filtered-list.model";

/**
 * Configuration data for BlogsFilteredList component
 */
export interface BlogsFilteredListProps {
    popularPosts: PopularPostsViewProps;
    searchQuery: string;
    noResultsText: string;
}

export function BlogsFilteredList({popularPosts, searchQuery, noResultsText}: BlogsFilteredListProps): JSX.Element {
    const data: BlogsFilteredListProps = {
        popularPosts,
        searchQuery,
        noResultsText,
    };

    const [model, snapshot] = useModel<BlogsFilteredListInstance, [BlogsFilteredListProps]>(createBlogsFilteredListModel, data);
    useServerRouter(model);

    useUpdateEffect(() => {
        model.update(data);
    }, [popularPosts, searchQuery]);

    return (
        <PopularPosts
            className="archive_blog"
            {...popularPosts}
            visiblePosts={snapshot.visiblePosts}
            hasMore={snapshot.hasMore}
            isLoading={snapshot.isLoading}
            isButtonLoading={snapshot.isButtonLoading}
            activeTag={snapshot.activeTag}
            searchModel={model.search}
            noResultsText={noResultsText}
            onTagChange={(tag: string) => model.setActiveTag(tag)}
            onLoadMore={() => model.loadMore()}
            space={{pt: "30px", ptm: "0px"}}
            showTagSlider={true}
            showSearch={true}
        />
    );
}
